<template>
  <SimpleComparisonRow :number-products="numberProducts" :data="data" :index="index" :no-highlight="$parent.noHighlight">
    <template v-slot="{ columnData }">
      <div class="similar-comparison-data-body">
        <template v-if="columnData['users-score'].value">
          {{ onFive(columnData['users-score'].value) }}
        </template>
        <span v-else>{{ $t('generic.n_a') }}</span>
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    numberProducts: {
      type: Number,
      default: 4,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SimpleComparisonRow,
  },
  methods: {
    onFive(value) {
      return (value / 20).toFixed(1) + '/5';
    },
  },
};
</script>
